import { memo } from 'react';
import cn from 'classnames';
import { Grid, Button, BUTTON_THEMES } from 'ht-styleguide';
import Banner from '@components/UI/Banner/index';
import styles from './pagebannercta.module.scss';

/* Types */
export type PageBannerWithCtaProps = {
  text?: string;
  className?: string;
  onMore?: BaseAnyFunction;
};

const PageBannerWithCta = ({ text, onMore, className }: PageBannerWithCtaProps) => (
  <Banner className={cn(styles.banner, className)}>
    <Grid.FullWidth dataTestId="banner-with-cta">
      <div className={styles.container}>
        <h5 className={cn('h5 white', styles.text)}>{text}</h5>
        <Button theme={BUTTON_THEMES.INVERTED} className={styles.button} onClick={onMore}>
          Learn More
        </Button>
      </div>
    </Grid.FullWidth>
  </Banner>
);
export default memo(PageBannerWithCta);
